import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ChatbotFlowsAPI from '../../api/chatbotFlows';
import InboxesAPI from '../../api/inboxes';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetchingItem: false,
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getChatbotFlows($state) {
    return $state.records;
  },
  getChatbotFlow: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isFetching: true });
    try {
      const response = await ChatbotFlowsAPI.get();
      commit(types.SET_CHATBOT_FLOWS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isFetching: false });
    }
  },
  getSingle: async ({ commit }, id) => {
    commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await ChatbotFlowsAPI.show(id);
      commit(types.ADD_CHATBOT_FLOW, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isFetchingItem: false });
    }
  },
  create: async ({ commit }, flowObj) => {
    commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isCreating: true });
    try {
      const response = await ChatbotFlowsAPI.create(flowObj);
      commit(types.ADD_CHATBOT_FLOW, response.data.payload);
      return response.data.payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isUpdating: true });
    try {
      const response = await ChatbotFlowsAPI.update(id, updateObj);
      commit(types.EDIT_CHATBOT_FLOW, response.data.payload);
      return response.data.payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isUpdating: false });
    }
  },
  setInboxFlow: async (_, { inboxId, flowId }) => {
    try {
      await InboxesAPI.setChatbotFlow(inboxId, flowId);
    } catch (error) {
      throwErrorMessage(error);
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isDeleting: true });
    try {
      await ChatbotFlowsAPI.delete(id);
      commit(types.DELETE_CHATBOT_FLOW, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CHATBOT_FLOWS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CHATBOT_FLOWS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.ADD_CHATBOT_FLOW]: MutationHelpers.setSingleRecord,
  [types.SET_CHATBOT_FLOWS]: MutationHelpers.set,
  [types.EDIT_CHATBOT_FLOW]: MutationHelpers.update,
  [types.DELETE_CHATBOT_FLOW]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
